import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box } from "@mui/material";
import toast from "react-hot-toast";

function createData(id, isApproved, rating, customerdetails, comment, status) {
  return {
    id,
    isApproved,
    rating,
    customerdetails,
    comment,
    status,
  };
}

const Viewallfeedbacks = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [allFeedbacks, setAllFeedbacks] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [copied, setCopied] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [confirmRowId, setConfirmRowId] = React.useState(null);

  useEffect(() => {
    getAllFeedbacks();
  }, []);

  const getAllFeedbacks = async (
    customPage = paginationModel?.page,
    customRowsPerPage = paginationModel?.pageSize,
  ) => {
    setLoading(true);
    const offset =
      (customPage ?? 0) * (customRowsPerPage ?? paginationModel?.pageSize);
    let query = "";

    try {
      const response = await fetch(
        `${apiUrl}/api/customerfeedbacks?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllFeedbacks(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 70,
      align: "start",
      sortable: false,
    },
    {
      field: "isApproved",
      headerName: "Is Approved",
      minWidth: 130,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        const isApproved = params.value;

        return (
          <span
            className={`font-semibold ${
              isApproved ? "text-green-600" : "text-red-600"
            }`}
          >
            {isApproved ? "Approved" : "Not Approved"}
          </span>
        );
      },
    },
    {
      field: "rating",
      headerName: "Rating",
      minWidth: 200,
      align: "start",
      renderCell: (params) => {
        const rating = params.value || 0;

        return (
          <div className="flex items-center gap-1 text-xl">
            {[...Array(5)].map((_, index) => (
              <span
                key={index}
                className={index < rating ? "text-yellow-500" : "text-gray-300"}
              >
                ★
              </span>
            ))}
          </div>
        );
      },
    },
    {
      field: "customerdetails",
      headerName: "Customer Details",
      minWidth: 350,
      align: "start",
    },
    {
      field: "comment",
      headerName: "Comment",
      minWidth: 500,
      align: "start",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 190,
      align: "start",
      renderCell: (params) => {
        const isApproved = params.row.isApproved;
        const rowId = params.row.id;
        const isConfirming = confirmRowId === rowId;

        const handleApprove = async () => {
          try {
            const response = await fetch(`${apiUrl}/api/customerfeedbacks`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `${token}`,
              },
              body: JSON.stringify({
                isApproved: true,
                id: rowId,
              }),
            });

            const data = await response.json();

            if (data?.statusCode === "0100") {
              toast.success("Comment Approved");
              await getAllFeedbacks(
                paginationModel?.page,
                paginationModel?.pageSize,
              );
            } else {
              toast.error(data?.msg);
            }
          } catch (error) {
            console.error("Error approving comment:", error);
          } finally {
            setConfirmRowId(null);
          }
        };

        // Already approved
        if (isApproved) {
          return (
            <button
              disabled
              className="px-4 py-1.5 text-sm font-semibold rounded-md bg-gray-300 text-gray-600 cursor-not-allowed"
            >
              Approved
            </button>
          );
        }

        // Confirmation buttons (ONLY for this row)
        if (isConfirming) {
          return (
            <div className="flex gap-2 mt-3">
              <button
                onClick={handleApprove}
                className="px-3 py-1 text-sm font-semibold rounded-md bg-blue-600 text-white hover:bg-blue-700"
              >
                Yes
              </button>
              <button
                onClick={() => setConfirmRowId(null)}
                className="px-3 py-1 text-sm font-semibold rounded-md bg-red-500 text-white hover:bg-red-600"
              >
                No
              </button>
            </div>
          );
        }

        // Default Approve
        return (
          <button
            onClick={() => setConfirmRowId(rowId)}
            className="px-4 py-1.5 text-sm font-semibold rounded-md bg-green-600 text-white hover:bg-green-700"
          >
            Approve
          </button>
        );
      },
    },
  ];

  const rows =
    (allFeedbacks &&
      allFeedbacks?.map((item) =>
        createData(
          item?.id,
          item?.isApproved,
          item?.rating,
          item?.customerDetails?.name +
            " / " +
            item?.customerDetails?.email +
            " / " +
            item?.customerDetails?.mobile,
          item?.comment || "-",
          "Approve and Publish",
        ),
      )) ||
    [];
  return (
    <>
      <h1 className="text-lg font-bold mt-4">View All Feedbacks</h1>
      <div className="mt-4">
        <Commongrid
          rows={rows}
          columns={columns}
          totalCount={totalCount}
          handleViewClick={() => {}}
          api={getAllFeedbacks}
          setPaginationModel={setPaginationModel}
          paginationModel={paginationModel}
          loading={loading}
          disableColumnMenu={true}
        />
      </div>
    </>
  );
};

export default Viewallfeedbacks;
